import type { UserInfo } from "@/stores/auth";
import { api } from "./api";

export const userService = {
  listAll: () => api.get<UserInfo[]>("/users"),

  getMe: () => api.get<UserInfo>("/users/me"),

  updateMe: (data: { name?: string; avatar?: string }) =>
    api.put<UserInfo>("/users/me", data),

  changePassword: (old_password: string, new_password: string) =>
    api.put("/users/me/password", { old_password, new_password }),

  getUser: (id: string) => api.get<UserInfo>(`/users/${id}`),

  setAdmin: (id: string, is_admin: boolean) =>
    api.put(`/users/${id}/admin`, { is_admin }),
};
